import {
    // AWS Catalog Definition Ids
    AwsEC2CatalogDefinitionId,
    AwsRHELCatalogDefinitionId,
    AwsSLESCatalogDefinitionId,
    AwsOELCatalogDefinitionId,
    AwsOracle19CCatalogDefinitionId,
    AwsSQLRDSCatalogDefinitionId,
    AwsOracleRDSCatalogDefinitionId,
    AwsS3BucketCatalogDefinitionId,
    AwsPostgresqlCatalogDefinitionId,
    AwsSQLIaasCatalogDefinitionId,
    AwsEksnCatalogDefinitionId,
    AwsDynamoDbCatalogDefinitionId,
    AwsALBCatalogDefinitionId,
    AwsNLBCatalogDefinitionId,
    AwsInternalUrlOnboardingCatalogDefinitionId,
    AwsCloudOnboardingCatalogDefinitionId,
    AwsAccountVendingCatalogDefinitionId,
    AwsLexCatalogDefinitionId,
    AwsExternalURLOnboardingCatalogDefinitionId,
    AwsDocumentDBCatalogDefinitionId,
    // Azure Catalog Definition Ids
    windowsCatalogDefinitionId,
    pgcsWindowsVmCatalogDefinitionId,
    pgcsSqlIaaSCatalogDefinitionId,
    sqlIaaSCatalogDefinitionId,
    sqlPaaSCatalogDefinitionId,
    MySQLFlexibleDbCatalogDefinitionId,
    couchbaseDbDefinitionId,
    linuxCatalogDefinitionId,
    SlesPgtCatalogDefinitionId,
    SlesPgtDBCatalogDefinitionId,
    oelOracleCatalogDefinitionId,
    storageCatalogDefinitionId,
    aksCatalogDefinitionId,
    keyvaultCatalogDefinitionId,
    AlbCatalogDefinitionId,
    kafkaCatalogDefinitionId,
    pECatalogDefinitionId,
    eventhubDefinitionId,
    InternalApplicationGateWayURLCatalogDefinitionID,
    NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
    NsgAutomationRulesProvisioningCatalogDefinitionID,
    PostgreSQLFlexibleDbCatalogDefinitionId,
    edapAksCatalogDefinitionId,
    CosmosDbCatalogDefinitionId,
    VirtualServiceCatalogDefinitionId,
    CloudOnboardingCatalogDefinitionID,
    ApplicationGateWayURLCatalogDefinitionID,
    ExternalPublicLoadBalancerURLCatalogDefinitionID,
} from 'utils/catalogDefinitionId';

const catalogEntries = (json, serviceType, ...definitionIds) => definitionIds?.map((definitionId) => ({ ids: definitionId, json, serviceType }));

export const GUIDE_TOUR_CATALOG_STEP_MAP = [
    // AWS Guided Tours
    ...catalogEntries('AWSWINVM2022.json', 'aws', AwsEC2CatalogDefinitionId),
    ...catalogEntries('AWSRHELVM.json', 'aws', AwsRHELCatalogDefinitionId, AwsSLESCatalogDefinitionId, AwsOELCatalogDefinitionId),
    ...catalogEntries('AWSOELORA19C.json', 'aws', AwsOracle19CCatalogDefinitionId),
    ...catalogEntries('AWSSQLRDSINSTANCE.json', 'aws', AwsSQLRDSCatalogDefinitionId),
    ...catalogEntries('AWSORACLERDSINSTANCE.json', 'aws', AwsOracleRDSCatalogDefinitionId),
    ...catalogEntries('AWSS3BUCKET.json', 'aws', AwsS3BucketCatalogDefinitionId),
    ...catalogEntries('AWSPOSTGRESQLRDSINSTANCE.json', 'aws', AwsPostgresqlCatalogDefinitionId),
    ...catalogEntries('AWSWINSQLIAAS.json', 'aws', AwsSQLIaasCatalogDefinitionId),
    ...catalogEntries('AWSEKSNS.json', 'aws', AwsEksnCatalogDefinitionId),
    ...catalogEntries('AWSDYNAMODBINSTANCE.json', 'aws', AwsDynamoDbCatalogDefinitionId),
    ...catalogEntries('AWSALB.json', 'aws', AwsALBCatalogDefinitionId),
    ...catalogEntries('AWSNLBINSTANCE.json', 'aws', AwsNLBCatalogDefinitionId),
    ...catalogEntries('AWSINTERNALURLONBOARD.json', 'aws', AwsInternalUrlOnboardingCatalogDefinitionId),
    ...catalogEntries('AWSCLOUDONBOARD.json', 'aws', AwsCloudOnboardingCatalogDefinitionId),
    ...catalogEntries('AWSACCOUNTONBOARD.json', 'aws', AwsAccountVendingCatalogDefinitionId),
    ...catalogEntries('AWSLEXBOT.json', 'aws', AwsLexCatalogDefinitionId),
    ...catalogEntries('AWSEXTERNALURLONBOARD.json', 'aws', AwsExternalURLOnboardingCatalogDefinitionId),
    ...catalogEntries('AWSDOCUMENTDB.json', 'aws', AwsDocumentDBCatalogDefinitionId),
    // Azure Guided Tours
    ...catalogEntries('AZWINVM2016.json', 'azure', windowsCatalogDefinitionId),
    ...catalogEntries('PGCSWINVM2022.json', 'azure', pgcsWindowsVmCatalogDefinitionId),
    ...catalogEntries('PGCSWINSQLIAAS.json', 'azure', pgcsSqlIaaSCatalogDefinitionId),
    ...catalogEntries('AZWINSQLIAAS.json', 'azure', sqlIaaSCatalogDefinitionId),
    ...catalogEntries('AZSQLPAAS.json', 'azure', sqlPaaSCatalogDefinitionId),
    ...catalogEntries('AZMYSQLINSTANCE.json', 'azure', MySQLFlexibleDbCatalogDefinitionId),
    ...catalogEntries('COUCHBASEDB.json', 'azure', couchbaseDbDefinitionId),
    ...catalogEntries('AZRHEL8VM.json', 'azure', linuxCatalogDefinitionId),
    ...catalogEntries('AZPGTSAPSLES15VM.json', 'azure', SlesPgtCatalogDefinitionId),
    ...catalogEntries('AZPGTSAPSLESHANADB.json', 'azure', SlesPgtDBCatalogDefinitionId),
    ...catalogEntries('AZOELORA19C.json', 'azure', oelOracleCatalogDefinitionId),
    ...catalogEntries('AZSTORAGE.json', 'azure', storageCatalogDefinitionId),
    ...catalogEntries('AZAKSNS.json', 'azure', aksCatalogDefinitionId),
    ...catalogEntries('AZKEYVAULT.json', 'azure', keyvaultCatalogDefinitionId),
    ...catalogEntries('AZLOADBAL.json', 'azure', AlbCatalogDefinitionId),
    ...catalogEntries('CFKAFKA.json', 'azure', kafkaCatalogDefinitionId),
    ...catalogEntries('AZUREPE.json', 'azure', pECatalogDefinitionId),
    ...catalogEntries('AZEVENTHUB.json', 'azure', eventhubDefinitionId),
    ...catalogEntries('AZINTAGWURLONBOARD.json', 'azure', InternalApplicationGateWayURLCatalogDefinitionID),
    ...catalogEntries('AZNEWINTAPPGW.json', 'azure', NewInternalApplicationGateWayProvisioningCatalogDefinitionID),
    ...catalogEntries('AZAPPNSGRULES.json', 'azure', NsgAutomationRulesProvisioningCatalogDefinitionID),
    ...catalogEntries('AZPOSTGRESQLINSTANCE.json', 'azure', PostgreSQLFlexibleDbCatalogDefinitionId),
    ...catalogEntries('AZEDAPAKSNS.json', 'azure', edapAksCatalogDefinitionId),
    ...catalogEntries('AZCOSMOSDB.json', 'azure', CosmosDbCatalogDefinitionId),
    ...catalogEntries('AZAKSVIRTUALSERVICE.json', 'azure', VirtualServiceCatalogDefinitionId),
    ...catalogEntries('CLOUDONBOARD.json', 'azure', CloudOnboardingCatalogDefinitionID),
    ...catalogEntries('AZAGWURLONBOARD.json', 'azure', ApplicationGateWayURLCatalogDefinitionID),
    ...catalogEntries('AZPLBURLONBOARD.json', 'azure', ExternalPublicLoadBalancerURLCatalogDefinitionID),
];

export const GUIDE_TOUR_CATALOG_IDS = GUIDE_TOUR_CATALOG_STEP_MAP.flatMap(({ ids }) => ids || []);
